import { render } from "./App.vue?vue&type=template&id=6b6eb6bc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6b6eb6bc&lang=scss"

import exportComponent from "/home/runner/work/acnh-tracker/acnh-tracker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__